import { ace_index } from '@axo/shared/data-access/types';
import { Dispatch } from 'react';
import { UseQueryResult } from 'react-query';

export function usePaginationSearch({
  defaultStartPage = 1,
  query,
  PageNumber,
  setPageNumber,
}: {
  query: UseQueryResult<ace_index.FindResult, unknown>;
  defaultStartPage?: number;
  PageNumber: number;
  setPageNumber: Dispatch<React.SetStateAction<number>>;
}) {
  const paginationParameters = query?.data?.Parameters;

  const firstPage = () =>
    paginationParameters && setPageNumber(defaultStartPage);

  const lastPage = () =>
    paginationParameters && setPageNumber(paginationParameters.TotalPages);

  const nextPage = () => paginationParameters && setPageNumber(PageNumber + 1);

  const previousPage = () =>
    paginationParameters && setPageNumber(PageNumber - 1);

  const disabledNext =
    paginationParameters &&
    paginationParameters.PageNumber >= paginationParameters.TotalPages;

  const disabledPrevious =
    paginationParameters && paginationParameters.PageNumber <= defaultStartPage;

  return {
    firstPage,
    lastPage,
    nextPage,
    previousPage,
    disabledNext,
    disabledPrevious,
  };
}
